export default () => ({
  screenInformation: {
    externalIdPublicA : null,
    isUa              : false,
    adjustmentTypes   : [
      {
        name  : '',
        value : '',
        items : []
      },
      {
        name  : '',
        value : '',
        items : []
      }
    ]
  }
});
